import { useQuery } from "@tanstack/react-query";
import fetchJSON from "../lib/reactQueryClient";

import tokenUtils from "../utils/tokenUtils";
import {  REACT_APP_CALL_SERVICE_URL } from "../constants/constants";

export const getCallLogs = async (calleeId, adminId) => {
  const token = tokenUtils.getToken();
  const endpoint = `${REACT_APP_CALL_SERVICE_URL}/get-call-logs?callee_id=${calleeId}&caller_id=${adminId}`;

  const options = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return await fetchJSON(endpoint, options);
};

export const useGetCallLogs = (calleeId, adminId, isEnabled = true) => {
  return useQuery({
    queryKey: ["callLogs", calleeId, adminId],
    queryFn: () => getCallLogs(calleeId, adminId),
    enabled: !!calleeId && !!adminId && isEnabled,
    retry: 1,
  });
};
